export class Row {
    id:number;
    seleccionado: boolean = false;
    objeto:any;
    valores: any[];
    valoresOriginales: any[];
    constructor(id:number, valores:string[], objeto = undefined){
        this.id = id;
        this.valores = valores;
        this.objeto = objeto;
        this.valoresOriginales = Object.assign({},valores);
    }
}